import { ReactNode, useState } from "react"
import {
  DimensionValue,
  ViewProps,
} from "@/components/wrappers/Spectrum/SpectrumTypes.ts"
import { Text, View,Divider } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

import { SideBarExpandButton } from "@/components/app/SideBars/SideBarExpandButton.tsx"
import ChevronRight from "@spectrum-icons/workflow/ChevronRight"
import ChevronLeft from "@spectrum-icons/workflow/ChevronLeft"

const style = { color: "white", backgroundColor: "#024f82" }

type SideBarProps = {
  children: ReactNode
  expanded?: (value: boolean) => boolean
  maxWidth?: DimensionValue
  minWidth?: DimensionValue
  position: "left" | "right"
}

const left: ViewProps<6> = {
  borderTopEndRadius: "regular",
  borderBottomEndRadius: "regular",
}

const right: ViewProps<6> = {
  borderTopStartRadius: "regular",
  borderBottomStartRadius: "regular",
}

export function SideBar({ position, children }: Readonly<SideBarProps>) {
  const [expanded, setExpanded] = useState(false)
  // const [size, setSize] = useState<DimensionValue>("size-550")

  const corners: ViewProps<6> = position === "left" ? left : right

  function onPress() {
    setExpanded((prevState) => !prevState)
    // setSize((prevState) =>
    //   prevState === "size-550" ? "size-3000" : "size-550"
    // )
  }

  return (
    <View
      height="100%"
      minWidth={expanded ? "size-3000" : "size-550"}
      maxWidth={expanded ? "size-3000" : "size-550"}
      paddingY="size-65"
      UNSAFE_className="ease-in-out duration-300"
      zIndex={100}
    >
      <View
        colorVersion={6}
        height="100%"
        overflow="hidden"
        UNSAFE_style={style}
        {...corners}
      >
        <View height="size-400">
          <SideBarExpandButton onPress={onPress}>
            {position === "right" &&
              (expanded ? <ChevronRight size="M"/> : <ChevronLeft size="M"/>)}
            {position === "left" &&
              (expanded ? <ChevronLeft size="M"/> : <ChevronRight size="M"/>)}
          </SideBarExpandButton>
        </View>
        <View height={`calc(100% - ${expanded? `size-800`:`size-400`})`} paddingBottom="size-50">
          <View
            overflow="scroll"
            height="100%"
            UNSAFE_style={{
              scrollBehavior: "smooth",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {children}
          </View>

        </View>
        {expanded && <>
          <Divider UNSAFE_style={{background:"green"}} height="size-25"/>
          <View height="size-400" UNSAFE_style={{alignItems: "center", justifyContent: "center",display:"flex",flexDirection:"column"}}>
            <Text>Kims Hospitals</Text>
          </View>
        </>}


      </View>
    </View>
  )
}
